async function loadTailwindPlusElementsIfNeeded(): Promise<void> {
  const hasTailwindPlusElements = Array.from(document.getElementsByTagName('*')).some(
    (element: Element) => element.localName.startsWith('el-'),
  );

  if (!hasTailwindPlusElements) return;

  await import('@tailwindplus/elements');
}

import { Collapse } from '../../views/twig/components/Collapse';
import { LazyLoader } from '../twig/components/LazyLoader';
import { PageAppear } from '../twig/components/PageAppear';
import { ModuleGallery } from '../twig/modules/gallery';
import { Page404 } from '../twig/pages/404';
import { PageArchive } from '../twig/pages/archive';

void loadTailwindPlusElementsIfNeeded();

(new Collapse()).init();
(new LazyLoader()).init();
(new PageAppear()).init();
(new Page404()).init();
(new ModuleGallery()).init();
(new PageArchive()).init();
